export interface RoutesDrawerMapModeFilterSetting {
    /**
     * The routes drawer filter selected metrics
     */
    filterMetric: string[];

    /**
     * The routes drawer filtered results count
     */
    filteredResultsCount: number;

    /**
     * The routes drawer unfiltered total count
     */
    unfilteredTotalCount: number;
}

export interface RoutesDrawerFilterState {
    /**
     * The routes drawer sort setting for `plan` map route mode
     */
    plan: RoutesDrawerMapModeFilterSetting;

    /**
     * The routes drawer sort setting for `dispatched` map route mode
     */
    dispatched: RoutesDrawerMapModeFilterSetting;

    /**
     * The routes drawer sort setting for `completed` map route mode
     */
    completed: RoutesDrawerMapModeFilterSetting;
}

export type RoutesDrawerFilterMapMode = keyof Pick<
    RoutesDrawerFilterState,
    'plan' | 'dispatched' | 'completed'
>;

export interface RoutesDrawerMapModeFilterMetricPayload {
    /**
     * The map route mode
     */
    mapMode: string;

    /**
     * the map route mode filter metric
     */
    filterMetric: string[];
}

export interface RoutesDrawerMapModeFilterCountPayload {
    /**
     * The map route mode
     */
    mapMode: string;

    /**
     * the map route mode filter results count
     */
    count: number;
}

export const defaultRoutesDrawerMapModeFilterMetric: RoutesDrawerMapModeFilterSetting =
    {
        filterMetric: [],
        filteredResultsCount: 0,
        unfilteredTotalCount: 0
    };

export const defaultRoutesDrawerFilter: RoutesDrawerFilterState = {
    plan: defaultRoutesDrawerMapModeFilterMetric,
    dispatched: defaultRoutesDrawerMapModeFilterMetric,
    completed: defaultRoutesDrawerMapModeFilterMetric
};
